
import { useSelector } from "react-redux";
import { useState } from "react";

import { TEMPLATE } from "../../../constants";

// Constants Library
import { COL_ATTENDENCE_LOG, COL_DAILY_PERFORMANCE, COL_DEVICE_LOG, COL_INCIDENT_LOG, COL_HISTORY_PRETRIP } from '../constant/index'

// Redux Actions

import { REDUX as REDUX_UTIL} from '../../../services/util'
import { ModalImage } from "../../../components";
import PretripContentDrawer from "../components/Pretrip/SidePanel/PretripContentDrawer";
// import { Alert, Button, Divider, Tag } from "antd";
import { pdf_handler } from "../../../handlers";

const { reduxStoreWrapper } = REDUX_UTIL;

const { 
  DRIVER_PRETRIP_RISK_LABEL,
//   DRIVER_PRETRIP_RISK_COLOR,
//   DRIVER_PRETRIP_CHECKLIST_CATEGORY_LABEL
} = TEMPLATE.DRIVER

export const reportHDLR = (selectedType) => {

  const summmary = useSelector(reduxStoreWrapper("reports.summary")) || []
  const drivers = useSelector(reduxStoreWrapper("drivers.byID"))
  const driverPretrips = useSelector(reduxStoreWrapper("drivers.pretripByID"))
  const driverSchedules = useSelector(reduxStoreWrapper("drivers.schedulesByID"))
  const vehicles = useSelector(reduxStoreWrapper("vehicles.staticsByID"))
  const geofences = useSelector(reduxStoreWrapper('geofences.byID'))
  const driverScoringData = useSelector(reduxStoreWrapper('drivers.KPIDashboards.driverLogsByCreatedAt'))
  // const driverPretripChecklists = useSelector(state => state.containers.v3.driverPretripChecklists)

  const searchTextState = useState('')
  const searchedColumnState = useState('')

  const [files, setFiles] = useState(null)
  const [isOpen, setIsOpen] = useState(false)
  const [isOpenDrawer, setIsOpenDrawer] = useState(false)
  const [data, setData] = useState(null)

    // const openVideoHDLR = () => {
    //     dispatch(ACTIONS.v3_liveCamera.set_selected_live_camera_by_vid_request(point.vid, point.mdvrid, false, point.attachments))
    // }

    const modalHDLR = (open, file) => {
        setFiles(file)
        setIsOpen(open)

        file && file.forEach(f => {
            window.open(f, '_blank')
        })
    }

    const drawerPretripHDLR = (open, file) => {
      setIsOpenDrawer(open)
      setData(file)
    }

  let dataColumn = () => {};
  let dataReport = []
  let fileName = ''

  switch(selectedType){
    case 'attendance':
      dataColumn = COL_ATTENDENCE_LOG(searchTextState, searchedColumnState); 
      dataReport = summmary.map((t, index) => ({...t, key: index})).sort((a, b) => b.reportTime - a.reportTime)
      fileName = 'DriverAttendanceLogSummary'
      break;
    case 'performance':
      dataColumn = COL_DAILY_PERFORMANCE(searchTextState, searchedColumnState); 
      dataReport = summmary.map((t, index) => {
        const trip_duration = t.plat_daily_engine_hour / t.tripNumber
        return {
          ...t, 
          key: index,
          name: drivers?.[t.drvid]?.name,
          icNumber: drivers?.[t.drvid]?.icNumber,
          plate: vehicles?.[t.vid]?.plate,
          trip_duration
      }}).sort((a, b) => Number(a.reportTime) - Number(b.reportTime))
      fileName = 'DriverPerformanceSummary'
      break;

    case 'incident':
      dataColumn = COL_INCIDENT_LOG(searchTextState, searchedColumnState, modalHDLR); 
      dataReport = summmary.map((t, index) => {
        const trip_duration = t.plat_daily_engine_hour / t.tripNumber
        return {
          ...t, 
          key: index,
          name: drivers?.[t.drvid]?.name,
          icNumber: drivers?.[t.drvid]?.icNumber,
          plate: vehicles?.[t.vid]?.plate,
          trip_duration
      }}).sort((a, b) => b.incidentTime - a.incidentTime)
      fileName = 'DriverPerformanceSummary'
      break;

    case 'pretrip':
      dataColumn = COL_HISTORY_PRETRIP(searchTextState, searchedColumnState, drawerPretripHDLR); 

      dataReport = [...Object.values(driverPretrips), ...Object.values(driverSchedules)]?.map((t, index) => {
        const riskLabel = DRIVER_PRETRIP_RISK_LABEL[t.risk]

        const issues = t.pretripDetail && new Set(t.pretripDetails.reduce((acc, item) =>  !item.isChecked ? [...acc, item] : acc, [])).size || 0

        return {
          ...t, 
          key: index,
          risk: riskLabel,
          name: drivers?.[t.drvid]?.name,
          plate: vehicles?.[t.vid]?.plate,
          status: t.status || 'SUBMITTED',
          issues: `${issues} issue${issues > 1 && 's' || ''}`
      }}).sort((a, b) => b.createdAt - a.createdAt)

      fileName = 'HistoryPretrip'
      break;


    case 'device':
      dataColumn = COL_DEVICE_LOG({ searchTextState, searchedColumnState, geofences }); 
      dataReport = summmary.map((t, index) => ({...t, key: index, plate: vehicles[t.vid]?.plate || t.vid}))

      fileName = 'DeviceLogSummary'

      break;

    case 'driverScoring':
      dataReport = driverScoringData

      fileName = 'DeviceLogSummary'

      break;
    
  }


      const exportDetailToPDFHDLR = () => {
          pdf_handler.exportToPDF('pdf', `Pre-trip Detail_${data?.createdAt}`)
      }

    const pretrips = data?.pretripDetails?.reduce((acc, curr) => {
        const category = curr.category;
        
        if (!acc[category]) acc[category] = []
        
        acc[category].push(curr);
        
        return acc
    }, {});


  const ModalDriver = (isOpen || isOpenDrawer) 
    && (
      isOpen
      ?
      <ModalImage isOpen={isOpen} setIsOpen={modalHDLR} extra={files}/>
      :
        <PretripContentDrawer pretrips={pretrips} isOpenDrawer={isOpenDrawer} setIsOpenDrawer={setIsOpenDrawer} newData={data} exportDetailToPDFHDLR={exportDetailToPDFHDLR} />
    //   <DrawerWrapper
    //       title={`Submission Detail`}
    //       open={isOpenDrawer}
    //       onClose={() => {
    //         setIsOpenDrawer(false)
    //         setData(null)
    //       }}
    //   >
    //     <div id="pdf" style={{ marginBottom: '1em', padding: '.5em'}}>
    //       <h3>Driver Information</h3>
    //       <h4>Driver: {data.name}</h4>
    //       <h4>Vehicle: {data.plate}</h4>
    //       <h4>Date: {TIME.parseDate(data.createdAt)}</h4>
    //       <h4>Risk: <Tag color={DRIVER_PRETRIP_RISK_COLOR[data.risk]}>{data.risk}</Tag></h4>
    //       <Divider />
    //       {
    //         Object.keys(pretrips)
    //         .map((ptc, i) => {

    //           return (
    //             <div key={i} style={{ marginBottom: '10px'}}>
    //             <h3>{DRIVER_PRETRIP_CHECKLIST_CATEGORY_LABEL[ptc]}</h3>
    //             {
    //               pretrips[ptc]?.map((pt, i) => (
    //                   <Alert 
    //                     key={i}
    //                     style={{ marginBottom: '5px' }}
    //                     type={pt.isChecked? 'success' : 'error'}
    //                     message={pt.item}
    //                     banner
    //                 />
    //               ))
    //             }
    //             </div>
    //           )
    //         })
    //       }
    //       <Divider/>
    //       <h3>Driver Notes</h3>
    //       <p>{data.note || '-'}</p>
    //       <Divider />
    //       <h5>Submitted at: {TIME.parseDate(data.createdAt)}</h5>
    //     </div>
    //     <Button onClick={exportDetailToPDFHDLR}>Export PDF</Button>
    //   </DrawerWrapper>
    )
    || false

  return { dataColumn, dataReport, fileName, isOpen, files, ModalDriver, drawerPretripHDLR }
}